import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldPaydayOutlineGreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 2.67578L2.99414 5.83398C2.74805 5.95703 2.58398 6.16211 2.625 6.36719C2.625 10.1406 4.18359 16.6211 10.2539 19.4922C10.418 19.5742 10.582 19.5742 10.7051 19.4922C16.7754 16.5801 18.334 10.1406 18.375 6.36719C18.375 6.16211 18.2109 5.95703 18.0059 5.83398L10.5 2.67578ZM11.0332 0.748047L18.7441 4.0293C19.6465 4.43945 20.3438 5.30078 20.3438 6.36719C20.3027 10.4688 18.6211 17.8926 11.5664 21.2969C10.8691 21.625 10.0898 21.625 9.39258 21.2969C2.33789 17.8926 0.65625 10.4688 0.65625 6.36719C0.615234 5.30078 1.3125 4.43945 2.21484 4.0293L9.92578 0.748047C10.0898 0.666016 10.2949 0.625 10.5 0.625C10.6641 0.625 10.8691 0.666016 11.0332 0.748047Z",
			fill: "#107F47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.0625 7.4375C7.0625 8.14062 6.49609 8.6875 5.8125 8.6875V11.8125C6.49609 11.8125 7.0625 12.3789 7.0625 13.0625H13.9375C13.9375 12.3789 14.4844 11.8125 15.1875 11.8125V8.6875C14.4844 8.6875 13.9375 8.14062 13.9375 7.4375H7.0625ZM4.875 7.75C4.875 7.06641 5.42188 6.5 6.125 6.5H14.875C15.5586 6.5 16.125 7.06641 16.125 7.75V12.75C16.125 13.4531 15.5586 14 14.875 14H6.125C5.42188 14 4.875 13.4531 4.875 12.75V7.75ZM10.5 8.375C11.1641 8.375 11.7695 8.74609 12.1211 9.3125C12.4531 9.89844 12.4531 10.6211 12.1211 11.1875C11.7695 11.7734 11.1641 12.125 10.5 12.125C9.81641 12.125 9.21094 11.7734 8.85938 11.1875C8.52734 10.6211 8.52734 9.89844 8.85938 9.3125C9.21094 8.74609 9.81641 8.375 10.5 8.375Z",
			fill: "#107F47"
		})
	]
});
const ForwardRef = forwardRef(SvgIconShieldPaydayOutlineGreen);
export { ForwardRef as ReactComponent };
